<template>
  <div class="dialog-scroll">
    <el-dialog
      :visible.sync="dialogVisible"
      class="search-popup"
      @close="resetForms"
      :before-close="handleDialogClose">
      <div class="title">{{ $t("title.popup.system.owner.search") }}</div>
      <!-- 検索エリア start -->

      <el-form @submit.native.prevent :model="query" :rules="rules" ref="ownerPopupRuleForm">
        <el-row :gutter="16">
          <el-col class="col">
            <el-form-item prop="ownerExId" class="input_item">
              <el-input
                maxlength="20"
                :placeholder="$t('label.common.ownerIdPlaceHolder')"
                size="small"
                v-model="query.ownerExId"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="ownerName" class="input_item">
              <el-input
                maxlength="50"
                :placeholder="$t('label.common.ownerNamePlaceHolder')"
                size="small"
                v-model="query.ownerName"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="form-group">
              <narrow-down @click="searchOwner">
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
                {{ $t("button.common.cancelNarrow") }}
              </cancel-narrow-down>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 検索エリア end -->

      <!-- 检索結果 start -->
      <div class="search-common" v-show="isshow">
        <label class="font-size-16 lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select @change="changePageSize" v-model="query.pageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div id="popup-owner-search-result" v-show="isshow" class="master-table-type">
        <el-table :data="searchResult.body">
          <el-table-column
            class="font"
            prop="exId"
            :label="$t('label.popup.system.owner.label.ownerExId')"
            class-name="col-3"
          />
          <el-table-column
            prop="name"
            :label="$t('label.popup.system.owner.label.ownerName')"
            class-name="col-6"
          />
          <el-table-column
            prop="address"
            :label="$t('label.popup.system.owner.label.address')"
            class-name="col-7"
          />
          <el-table-column
            prop="telNo"
            :label="$t('label.popup.system.owner.label.telNo')"
            class-name="col-3"
          />
          <el-table-column class-name="col-2">
            <div slot-scope="scope" class="detail-button with-100">
              <sp-smart-button class="detailed-but with-100" @click="selectOwner(scope.row)">
                {{$t('button.common.select')}}
              </sp-smart-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 检索結果 end -->

      <!-- pagination start -->
      <pagination
        class="m-top-5"
        v-show="searchResult.body.length > 0"
        :page-size="query.pageSize"
        :page-number="searchResult.pageNumber"
        :totalPage="searchResult.totalPage"
        :totalCount="searchResult.totalCount"
        @on-paging="handlePageChange"
      >
      </pagination>
      <!-- pagination end -->

    </el-dialog>
  </div>

</template>

<script>
import PopupRulesFactory from "@/rules/rule-popup-owner";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import SpSmartButton from "@/components/common/sp-smart-button"

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;
const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    Pagination,
    narrowDown,
    cancelNarrowDown,
    SpSmartButton,
  },
  name: "OwnerSearchPopup",
  props: {
    ownerExIdParam: {
      type: String,
      default: null
    },
    ownerNameParam: {
      type: String,
      default: null
    },
    visible: Boolean,
    includeDeleteDataFlag: {
      type: Boolean,
      default: true
    },
    funcCode: {
      type: String,
      default: null
    },
  },
  data: function () {
    return {
      isshow: false,
      rules: PopupRulesFactory.popupRules(this),
      query: {
        ownerId: null,
        ownerExId: this.ownerExIdParam,
        ownerName: this.ownerNameParam,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
      },
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        body: [],
      },
      isSearching: false,
      dialogVisible: this.visible,
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  watch: {
    visible: function (value) {
      this.dialogVisible = value;
      this.query.ownerId = this.ownerIdParam;
      this.query.ownerName = this.ownerNameParam;
      this.query.ownerExId = this.ownerExIdParam;
    },
    // ownerIdParam: function (value) {
    //   this.query.ownerId = value;
    // },
    // ownerNameParam: function (value) {
    //   this.query.ownerName = value;
    // },
    // ownerExIdParam: function (value) {
    //   this.query.ownerExId = value;
    // }
  },
  methods: {

    resetForms() {
      this.$refs['ownerPopupRuleForm'].resetFields()
    },

    changePageSize(){
      this.query.pageNumber = 1
      this.searchOwner()
    },

    searchOwner: function () {
      this.$refs["ownerPopupRuleForm"].validate((valid) => {
        if (valid) {
          if (!this.isSearching) {
            this.isSearching = true;
            this.showTableLoadingAnim();
            if(this.includeDeleteDataFlag == null || this.includeDeleteDataFlag == undefined) {
              this.includeDeleteDataFlag = true
            }
            SystemManageApi.searchOwner({
              ownerId: this.query.ownerId,
              ownerName: this.query.ownerName,
              ownerExId: this.query.ownerExId,
              pageSize: this.query.pageSize,
              pageNumber: this.query.pageNumber,
              funcCode: this.funcCode,
              includeDeleteDataFlag: this.includeDeleteDataFlag,
            })
            .catch((error) => {
              errorCodeMsg(error, this)
            })
            .then((resp) => {
              this.searchResult.pageSize = resp.data.body.pageSize;
              this.searchResult.pageNumber = resp.data.body.pageNumber;
              this.searchResult = resp.data.body;
            }).finally(() => {
              this.isSearching = false;
              this.hideTableLoadingAnim();
            });
          }
          this.isshow = true;
        } else {
          return false;
        }
      });
    },

    //show anim
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#popup-owner-search-result",
          background: "#ebebe6"
        });
      }
    },

    //hide anim
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },

    selectOwner(owner) {
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, owner);
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    /**
     * clear
     */
    clearSearchParams: function () {
      this.query.ownerId = null;
      this.query.ownerName = null;
      this.query.ownerExId = null;
      this.query.pageSize = DEFAULT_PAGE_SIZE;
      this.query.pageNumber = DEFAULT_PAGE_NUMBER;
      this.searchResult.body = [];
      //this.$refs["ownerPopupRuleForm"].resetFields();
      this.isshow = false;
    },

    handleDialogClose: function () {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.clearSearchParams();
      this.isshow = false;
    },

    handlePageChange: function (paging) {
      this.query.pageSize = paging.pageSize;
      this.query.pageNumber = paging.pageNumber;
      this.searchOwner();
    }
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  font-size: 24px;
  // color: #2699fb;
}

.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  // overflow: hidden;
  color: #fff;

  ::v-deep.el-input__inner {
    border: none;
    // line-height: 24px;
    background-color: #f2f2ed;
    color: #525250;
    // font-size: 15px !important;
    // padding-left: 20px;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
}

.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.left-input {
  margin-top: 13px;
  width: 200px;
}
.right-input {
  margin-top: 13px;
  margin-left: 16px;
  width: 200px;
  height: 22px;
}
.col {
  display: flex;
  flex-direction: row;
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  // color: #2699fb;
  font-size: 12px;
}

.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}
::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}

// add by mxq
.input_item {
  margin-right: 20px;
  ::v-deep.el-input .el-input__inner {
    width: 296px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep.el-icon-close {
  color: rgb(0, 0, 0);
}
.button_title {
  font-size: 12px;
  position: relative;
  bottom: 6px;
}
.search-common {
  display: block;
  //float: right;
  text-align: right;
  margin-top: 36px;
  margin-bottom: 20px;
}
</style>
